export const PKG_NAME = "@hpcc-js/react";
export const PKG_VERSION = "2.55.6";
export const BUILD_VERSION = "2.108.11";
